/** @format */
import { Injector } from '@angular/core';

export abstract class InjectorService {
    abstract getRootInjector(): Injector;
    abstract setRootInjector(injector: Injector): void;
}
